import withCollegeService from '../withCollegeService';
import SchoolSize from './school-size';
import NearestCity from './nearest-city';
import Ethnicity from './ethnicity';
import AgeData from './age-data';
import GreekLife from './greek-life';
import HousingData from './housing-data';
import Services from './services';
import Organizations from '../services';

import ComputingResources from './computing-resources';
import Athletics from './athletics';

export const SchoolsizeComponent = withCollegeService(
  SchoolSize,
  'studentLife.schoolSize',
  {},
  {
    undergraduateWomen: 'field_he_numugfemales',
    undergraduateMen: 'field_he_numugmales',
    graduateWomen: 'field_he_numgradfemales',
    graduateMen: 'field_he_numgradmales',
  },
);

export const NearestCityComponent = withCollegeService(
  NearestCity,
  'studentLife.nearestCity',
  {},
  {
    city: 'field_he_nearestcity',
    distance: 'field_he_nearestmajorcitymiles',
  },
);

export const EthnicityComponent = withCollegeService(
  Ethnicity,
  'studentLife.ethnicity',
  {},
  {
    africanAmerican: 'field_he_pctafricanam',
    africanHispanic: 'field_he_pcthispanic',
    nativePacificIslander: 'field_he_pctnativepacificisland',
    twoOrMoreRaces: 'field_he_pcttwoormoreraces',
    caucasian: 'field_he_pctcaucasian',
    asian: 'field_he_pctasian',
    nativeAmerican: 'field_he_pctnativeam',
    nativeUnknown: 'field_he_pctraceunknown',
    nonResidentAlien: 'field_he_pctnonresidentalien',
    international: 'field_he_pctinternational',
  },
);

export const AgeDataComponent = withCollegeService(
  AgeData,
  'studentLife.ageData',
  {},
  {
    value: 'field_he_pctstudentsgt24yrsold',
  },
);

export const GreekLifeComponent = withCollegeService(
  GreekLife,
  'studentLife.greekLife',
  {},
  {
    fraternities: 'field_he_numsocialfrat',
    sororities: 'field_he_numsocialsor',
  },
);

export const HousingDataComponent = withCollegeService(
  HousingData,
  'studentLife.housingData',
  {},
  {
    campusHousingCapacity: 'field_he_camphouscap',
    liveOnCampus: 'field_he_pctliveoncamp',
    freshmanMustLiveOnCampus: 'field_he_freshmenmustliveoncampu',
    sophomoresMustLiveOnCampus: 'field_he_sophomoresmustliveoncam',
    juniorsMustLiveOnCampus: 'field_he_juniorsmustliveoncampus',
    seniorsMustLiveOnCampus: 'field_he_seniorsmustliveoncampus',
  },
);

export const ServicesComponent = withCollegeService(
  Services,
  'studentLife.services',
  {},
  {
    ROTCArmy: 'field_he_rotcarmy',
    ROTCNavy: 'field_he_rotcnavy',
    ROTCAirforce: 'field_he_rotcair',
    ROTCServicepersonOpportunityCollege: 'field_he_rotcservperoppcollege',
  },
);

export const OrganizationsComponent = withCollegeService(
  Organizations,
  'studentLife.organizations',
  {},
  {
    academicClubs: 'field_he_orgrepresented',
    academicFratSor: 'field_he_orgrepresented',
    business: 'field_he_orgrepresented',
    choir: 'field_he_orgrepresented',
    commuter: 'field_he_orgrepresented',
    concertBand: 'field_he_orgrepresented',
    environmental: 'field_he_orgrepresented',
    gayAndLesbian: 'field_he_orgrepresented',
    honorsAcademic: 'field_he_orgrepresented',
    international: 'field_he_orgrepresented',
    jazzBand: 'field_he_orgrepresented',
    literaryMagazine: 'field_he_orgrepresented',
    marchingBand: 'field_he_orgrepresented',
    minorityCultural: 'field_he_orgrepresented',
    minorityStudent: 'field_he_orgrepresented',
    newspaper: 'field_he_orgrepresented',
    orchestra: 'field_he_orgrepresented',
    phiBetaKappa: 'field_he_orgrepresented',
    physicallyChallenged: 'field_he_orgrepresented',
    politicalActivism: 'field_he_orgrepresented',
    preDental: 'field_he_orgrepresented',
    preLaw: 'field_he_orgrepresented',
    preMedical: 'field_he_orgrepresented',
    preVeterinary: 'field_he_orgrepresented',
    radioStation: 'field_he_orgrepresented',
    religious: 'field_he_orgrepresented',
    sportsIntramurals: 'field_he_orgrepresented',
    studentGovernment: 'field_he_orgrepresented',
    substanceAbuseSupport: 'field_he_orgrepresented',
    televisionStation: 'field_he_orgrepresented',
    theatreDrama: 'field_he_orgrepresented',
    yearbook: 'field_he_orgrepresented',
    phiThetaKappa: 'field_he_orgrepresented',
  },
);

export const ComputingResourcesComponent = withCollegeService(
  ComputingResources,
  'studentLife.computingResources',
  {},
  {
    numberOfMacsInComputerCenters: 'field_he_macsincomputercen',
    numberOfPCsInComputerCenters: 'field_he_pcsincomputercenters',
    numberOfMacsInDepartmentLabs: 'field_he_macsindepartmentlabs',
    numberOfPCsInDepartmentLabs: 'field_he_pcsindepartmentlabs',
    numberOfMacsInLibraries: 'field_he_macsinlibrary',
    numberOfPCsInLibraries: 'field_he_pcsinlibrary',
    numberOfMacsInStudentCenters: 'field_he_macsinstudentcenters',
    numberOfPCsInStudentCenters: 'field_he_pcsinstudentcenters',
    numberOfMacsInResidences: 'field_he_macsinresidences',
    numberOfPCsInResidences: 'field_he_pcsinresidences',
    numberOfMacsInOther: 'field_he_macsinother',
    numberOfPCsInOther: 'field_he_pcsinother',
    internetAccessInLibrary: 'field_he_internetinlibrary',
    wirelessInternetAccess: 'field_he_internetwireless',
    internetAccessOnCentralCampus: 'field_he_internetincentralloc',
    internetAccessInResidenceHalls: 'field_he_internetinresidencehall',
    computerRequired: 'field_he_computerrequired',
    computerRequiredReason: 'field_he_computerrequiredreason',
    computerPurchaseOffered: 'field_he_purchaseplanoffered',
    preferredComputerType: 'field_he_prefered_computer_type',
  },
);

export const AthleticsComponent = withCollegeService(
  Athletics, 'studentLife.athletics',
  [],
  {
    men: {
      association: 'he_assocmen_id',
      division: 'he_divmen_id',
      conference: 'he_confmen_id',
      others: {
        club: 'he_clubmen',
        intramural: 'he_intramuralmen',
      },
    },
    women: {
      association: 'he_assocwomen_id',
      division: 'he_divwomen_id',
      conference: 'he_confwomen_id',
      others: {
        club: 'he_clubwomen',
        intramural: 'he_intramuralwomen',
      },
    },
    coed: {
      association: 'he_assoccoed_id',
      division: 'he_divcoed_id',
      conference: 'he_confcoed_id',
      others: {
        club: 'he_clubcoed',
        intramural: 'he_intramuralcoed',
      },
    },
  },
  null,
  {
    type: 'he_schoolsport_us',
    fields: {},
  },
);

export {
  SchoolsizeComponent as SchoolSize,
  NearestCityComponent as NearestCity,
  EthnicityComponent as Ethnicity,
  AgeDataComponent as AgeData,
  GreekLifeComponent as GreekLife,
  HousingDataComponent as HousingData,
  ServicesComponent as Services,
  OrganizationsComponent as Organizations,
  ComputingResourcesComponent as ComputingResources,
  AthleticsComponent as Athletics,
};
